export default __webpack_public_path__ + "static/media/youtube-clone-app.6e04a555.PNG";